import ElhaghiyehHayeSaderehSliceType from './ElhaghiyehHayeSaderehSliceType';

const ElhaghiyehHayeSaderehInitialState: ElhaghiyehHayeSaderehSliceType = {
  elhaghiyehHayeSadereh: {
    loading: false,
    data: [],
  },
  print: {
    loading: false,
  },
};

export default ElhaghiyehHayeSaderehInitialState;
